<template>
  <svg class="svg-icon" aria-hidden="true" :name="name" :style="`width: ${size};height: ${size};color: ${color}`">
    <use ref="useRef" :xlink:href="symbolId" :fill="color" />
  </svg>
</template>

<script>
export default {
  name: 'SvgIconV2',
  props: {
    prefix: {
      type: String,
      default: 'icon'
    },
    name: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: '#333'
    },
    size: {
      type: String,
      default: '1em'
    }
  },
  computed: {
    symbolId() {
      return `#${this.prefix}-${this.name}`
    }
  }
}
</script>

<style scoped lang="scss">
.svg-icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  overflow: hidden;
}
</style>
